<template>
  <div class="jsmind">
    <div class="jsmind_layout" style="text-align: left;">
      <div id="jsmind_container" ref="container" @click="nodeClick" @contextmenu.prevent.stop="nodeClick" />
    </div>

    <!-- 右键菜单 -->
    <el-menu v-show="showMenu" ref="context" class="context-menu" :style="{
      left: menuStyle.left,
      top: menuStyle.top,
      bottom: menuStyle.bottom,
      right: menuStyle.right
    }">
      <slot>
        <el-menu-item @click="addBrother">插入平级</el-menu-item>
        <el-menu-item @click="addChild">插入子级</el-menu-item>
        <el-menu-item @click="delCard">删除卡片</el-menu-item>
      </slot>
    </el-menu>
  </div>
</template>
<script>
import './mind/style/jsmind.css'
import jsMind from './mind/js/jsmind.js'
window.jsMind = jsMind
require('./mind/js/jsmind.screenshot.js')
require('./mind/js/jsmind.drag.js')
export default {
  data() {
    return {
      mind: {
        meta: {
          name: '思维导图',
          author: '2247812391@qq.com',
          version: '0.2'
        },
        format: 'node_tree',
        data: {
          id: 'root',
          topic: '项目名称',
          type: '4',
          children: [
            // {
            //   id: 'open',
            //   topic: '样品编号',
            //   direction: 'right',
            //   expanded: true,
            //   type: '4'
            // },
            // {
            //   id: 'opens',
            //   topic: '报告结果',
            //   direction: 'right',
            //   expanded: true,
            //   type: '4'
            // }
          ]
        }
      },
      options: {
        container: 'jsmind_container', // [必选] 容器的ID
        editable: true, // [可选] 是否启用编辑
        theme: '', // [可选] 主题  
        mode: 'side',
        view: {
          engine: 'canvas', // 思维导图各节点之间线条的绘制引擎
          hmargin: 0, // 思维导图距容器外框的最小水平距离
          vmargin: 0, // 思维导图距容器外框的最小垂直距离
          line_width: 2, // 思维导图线条的粗细
          line_color: '#ddd' // 思维导图线条的颜色
        },
        layout: {
          hspace: 100, // 节点之间的水平间距
          vspace: 20, // 节点之间的垂直间距
          pspace: 20 // 节点与连接线之间的水平间距（用于容纳节点收缩/展开控制器）
        },
        shortcut: { // 禁用快捷键
          enable: false
        }
      },
      zoom: {
        value: 100, // 层级大小
        min: 10, // 最小层级
        max: 400 // 最大层级
      },
      bgMap: {
        1: {
          original: 'rgb(25, 144, 255)',
          transparent: 'rgb(25, 144, 255, 0.2)'
          // original: 'rgb(212, 42, 42)',
          // transparent: 'rgb(212, 42, 42, 0.2)'
        },
        2: {
          original: 'rgb(25, 144, 255)',
          transparent: 'rgb(25, 144, 255, 0.2)'
          // original: 'rgb(100, 201, 53)',
          // transparent: 'rgb(100, 201, 53, 0.2)'
        },
        3: {
          original: 'rgb(25, 144, 255)',
          transparent: 'rgb(25, 144, 255, 0.2)'
          // original: 'rgb(67, 50, 173)',
          // transparent: 'rgb(67, 50, 173, 0.2)'
        },
        4: {
          original: 'rgb(25, 144, 255)',
          transparent: 'rgb(25, 144, 255, 0.2)'
        }
      },
      structure: {
        active: 'right',
        pathOrginalColor: '#2B2F36',
        pathActiveColor: '#3370FF',
        rectOrginalColor: '#C3C6CB',
        rectActiveColor: '#BACEFD'
      },
      dialogVisible: false,
      selectNodeInfo: {
        id: null,
        Name: ''
      }, // 选中节点信息
      tempNodeInfo: null, // 保存修改之前的信息
      createType: '', // 添加平级or子级
      showMenu: false, // 是否显示右键菜单栏
      menuStyle: {
        top: '',
        bottom: '',
        left: '',
        right: ''
      },
      typeQueue: new Set(['1', '2', '3', '4']), // 选中types Set
      selectTypes: ['1', '2', '3', '4'] // 选中types Array
    }
  },
  computed: {
    pathColor() {
      return function (type) {
        return this.structure.active === type ? this.structure.pathActiveColor : this.structure.pathOrginalColor
      }
    },
    rectColor() {
      return function (type) {
        return this.structure.active === type ? this.structure.rectActiveColor : this.structure.rectOrginalColor
      }
    }
  },
  watch: {
    'zoom.value'(val) {
      const zoom = val / 100
      this.jm.view.setZoom(zoom)
    },
    selectTypes(v) {
      this.loopTreeData(this.mind.data.children, (item) => {
        if (v.length) {
          if (v.includes(item.type)) {
            this.jm.set_node_color(item.id, this.bgMap[item.type].original, '#fff')
          } else {
            this.jm.set_node_color(item.id, this.bgMap[item.type].transparent, '#fff')
          }
        } else {
          this.jm.set_node_color(item.id, this.bgMap[item.type].transparent, '#fff')
        }
      })
    }
  },
  mounted() { 
    const result = JSON.parse(localStorage.getItem('sampling'))
    // this.mind.data.topic = result.itemList[0].itemName
    this.mind.data.topic = result.modeName
    this.jm = jsMind.show(this.options, this.mind)
    this.editor = this.jm.view.e_editor
    this.init()
    this.mouseDrag()
    this.$nextTick({})
    jsMind.draggable.prototype.handleDrag = (srcNode, targetNode, targetDirect) => {
      const nextParentId = srcNode.parent.id
      this.handleDrop(nextParentId, srcNode.id)
    }
    let list = this.mind.data
    localStorage.setItem('list', JSON.stringify(list));
  },
  beforeDestroy() {
    document.removeEventListener('domMouseScroll', this.scrollFunc, false)
  },
  methods: {
    setData(data) {
      console.log(data, '传递过来的数据');
      this.mind.data = this.transformData(data);
      const list = JSON.stringify(this.mind.data.children);
      localStorage.setItem('list', list);
      const selectedNode = this.jm.get_data()
      selectedNode.data.children = this.mind.data.children
      this.jm.show(this.mind);
      this.jm.layout.layout();   
    },
    transformData(data) {
      if (!data) {
        return null;
      }

      const mindData = {
        id: data.id,
        topic: data.topic,
        type: '4',
        direction: 'right',
        expanded: true,
        children: [],
      };

      if (data.children && data.children.length > 0) {
        mindData.children = data.children.map(child => this.transformData(child));
      }

      return mindData;
    },


    getMindData() {
      let list = this.mind.data
      localStorage.setItem('list', JSON.stringify(list));
      console.log('获取当前思维导图数据', list);
    },
    // 筛选树结构
    toggleFilter(item) {
      item.status = !item.status
      item.status ? this.typeQueue.add(item.value) : this.typeQueue.delete(item.value)
      this.selectTypes = [...this.typeQueue]
    },

    // 重置视图
    reset() {
      document.querySelector('.root').scrollIntoView({
        block: 'center',
        behavior: 'smooth'
      })
    },

    // 循环树结构
    loopTreeData(list, callback) {
      (function doOneFloor(list) {
        if (Array.isArray(list)) {
          for (let i = 0; i < list.length; i++) {
            const item = list[i]
            callback(item, i)
            if (item.children && item.children.length > 0) {
              doOneFloor(item.children)
            }
          }
        }
      })(list)
    },

    // 设置背景颜色
    setColor() {
      this.jm.set_node_color('root', this.bgMap[4].original, '#fff')
      this.loopTreeData(this.mind.data.children, (item) => {
        if (this.selectTypes.length) {
          if (this.selectTypes.includes(item.type)) {
            this.jm.set_node_color(item.id, this.bgMap[item.type].original, '#fff')
          } else {
            this.jm.set_node_color(item.id, this.bgMap[item.type].transparent, '#fff')
          }
        } else {
          this.jm.set_node_color(item.id, this.bgMap[item.type].transparent, '#fff')
        }
      })
    },

    // 切换思维导图结构
    toggleStucture(type) {
      if (this.structure.active === type) return
      this.structure.active = type
      switch (type) {
        case 'right':
          // 向右分布
          this.loopTreeData(this.mind.data.children, (item) => { item.direction = 'right' })
          break

        default:
          break
      }

      this.jm.show(this.mind)
      this.init()
    },

    // 初始化配置
    init() {
      this.jm.view.minZoom = 0.1
      this.jm.view.maxZoom = 5
      this.jm.expand_all()
      this.setColor()

      // 重写编辑完成事件
      this.jm.view.edit_node_end = () => {
        const node = this.jm.view.get_editing_node()
        const viewData = node._data.view
        const element = viewData.element
        element.style.zIndex = 'auto'
        if (node.topic === this.editor.value) {
          this.jm.update_node(node.id, node.topic)
          return
        }
        node.topic = this.editor.value
        if (!node.topic) {
          this.$message.info('请输入卡片标题')
        }
        this.jm.update_node(node.id, node.topic)

        const selectedNode = this.jm.get_data()
        const circularReplacer = () => {
          const seen = new WeakSet();
          return (key, value) => {
            if (typeof value === "object" && value !== null) {
              if (seen.has(value)) {
                return undefined; // 排除循环引用对象
              }
              seen.add(value);
            }
            return value;
          };
        };
        const parentData = JSON.stringify(selectedNode.data, circularReplacer());
        console.log(parentData, '编辑后所有节点数据');
        localStorage.setItem('list', parentData);
      }

      // 右键菜单
      this.jm.view.add_event(this.editor, 'contextmenu', (e) => {
        const selectedNode = this.jm.get_selected_node()
        if (selectedNode && selectedNode.data.type) {
          console.log('我去少什么阿', selectedNode, selectedNode.data.type)
          e.preventDefault()
          const el = document.querySelector('.context-menu .el-menu-item')
          const width = parseFloat(window.getComputedStyle(el).width)
          const height = parseFloat(window.getComputedStyle(el).height) * 3 + 12
          const windowHeight = window.innerHeight
          const windowWidth = window.innerWidth

          // 极限位置 避免越界
          if (e.clientY + height > windowHeight) {
            this.menuStyle.left = e.clientX + 'px'
            this.menuStyle.top = 'unset'
            this.menuStyle.bottom = 0
          } else if (e.clientX + width > windowWidth) {
            this.menuStyle.top = e.clientY + 'px'
            this.menuStyle.left = 'unset'
            this.menuStyle.right = 0
          } else {
            this.menuStyle.left = e.clientX + 'px'
            this.menuStyle.top = e.clientY + 'px'
            this.menuStyle.bottom = 'unset'
          }
          this.showMenu = true
        } else {
          // console.log('22222222222222',selectedNode)
          this.showMenu = false
        }
      })
    },
    // 获取选中标签的 ID
    get_selected_nodeid() {
      const selectedNode = this.jm.get_selected_node()
      if (selectedNode) {
        return selectedNode.id
      } else {
        return null
      }
    },

    // 保存节点
    sureEditNode() {
      if (!this.selectNodeInfo.Name) {
        this.$message.info('请输入卡片标题')
        return
      }

      if (this.createType === 'bro') {
        // 平级
        // TODO 调接口
      } else {
        // 子级
        // TODO 调接口
      }
      this.dialogVisible = false
    },
    //递归处理数据
    findMatchingNode(node, targetId) {
      // 如果当前节点为null，或者当前节点的父节点的id等于目标id，则返回当前节点
      console.log(node, '--------->');
      if (node.id == targetId) {
        return node
      } else if (node.parent.id == targetId) {
        console.log(node, '匹配相等的数据');
        return node;
      } else {
        // 递归调用，继续在当前节点的子节点中查找
        return this.findMatchingNode(node.parent, targetId);
      }
    },
    getdata() {
      const selectedNode = this.jm.get_data()
      console.log(selectedNode,'---------->>>>');
      const circularReplacer = () => {
        const seen = new WeakSet();
        return (key, value) => {
          if (typeof value === "object" && value !== null) {
            if (seen.has(value)) {
              return undefined; // 排除循环引用对象
            }
            seen.add(value);
          }
          return value;
        };
      };

      // selectedNode.data.children = this.mind.data.children

      const parentData = JSON.stringify(this.jm.get_data('node_tree').data, circularReplacer());
      console.log(parentData, '修改后所有节点数据');
      localStorage.setItem('list', parentData);
    },
    // 拖拽
    handleDrop(draggingNode, dropNode) {
      // 前一个兄弟节点
      const prevNode = this.jm.find_node_before(dropNode)
      // 获取移动后的node
      const dragForm = {
        modelId: '',
        treeNum: !prevNode ? draggingNode : prevNode.id,
        thisTreeNum: dropNode
      }
      this.getdata()
    },
    // 单击重置选中背景颜色
    nodeClick() {
      const selectedId = this.get_selected_nodeid()
      if (!selectedId) return
      const nodeObj = this.jm.get_node(selectedId)
      this.jm.set_node_color(selectedId, nodeObj.data['background-color'], '#fff')
    },

    // 插入卡片
    insertNode() {
      const selectedNode = this.jm.get_selected_node()
      if (selectedNode.data) {
        this.$emit('insert', selectedNode.data)
      } else {
        this.$message.error('请选择卡片')
      }
      this.showMenu = false
    },
    // 插入平级
    addBrother() {
      const parentNode = this.jm.get_selected_node() // 获取当前选中的节点
      const newNodeId = 'newNodeId' + Date.now() // 使用时间戳来生成唯一的节点ID
      const newNodeTopic = '请双击节点输入' // 设置新节点的内容
      // 在当前选中节点的父节点下插入新节点
      this.jm.add_node(parentNode.parent.id, newNodeId, newNodeTopic, { type: '4', direction: 'right' })
      // 更新布局
      this.jm.layout.layout()

      this.getdata()
      this.showMenu = false
    },
    getNodeLevel(node) {
      let level = 0;
      while (node.parent) {
        level++;
        node = node.parent;
      }
      return level;
    },

    // 在 addChild 方法中添加层级检查
    addChild() {
      const selectedNode = this.jm.get_selected_node();
      if (selectedNode.data) {
        const maxAllowedLevel = 5; // 最大允许的层级

        // 获取选中节点的层级
        const selectedNodeLevel = this.getNodeLevel(selectedNode);

        if (selectedNodeLevel < maxAllowedLevel) {
          // 创建子级节点
          const newNodeId = 'newNodeId' + Date.now(); // 使用时间戳来生成唯一的节点ID
          const newNodeTopic = '固定内容'; // 设置新节点的内容

          // 在当前选中节点下插入新节点
          this.jm.add_node(selectedNode.id, newNodeId, newNodeTopic, { type: 'child' });

          // 每次新增更改表头数据
          this.getdata();

          // 重新布局
          this.jm.layout.layout();
        } else {
          this.$message.error('节点层级超过限制');
        }
      } else {
        this.$message.error('请选择卡片');
      }
      this.showMenu = false;
    },

    // 删除卡片
    delCard() {
      const selectedNode = this.jm.get_selected_node()
      if (selectedNode.data) {
        // TODO
        this.jm.remove_node(selectedNode.id)
        //删除跟新数据
        const circularReplacer = () => {
          const seen = new WeakSet();
          return (key, value) => {
            if (typeof value === "object" && value !== null) {
              if (seen.has(value)) {
                return undefined; // 排除循环引用对象
              }
              seen.add(value);
            }
            return value;
          };
        };
        const parentData = JSON.stringify(this.jm.get_data('node_tree').data, circularReplacer());
        console.log(parentData, '删除节点更新结构');
        localStorage.setItem('list', parentData);
      } else {
        this.$message.error('请选择卡片')
      }
      this.showMenu = false
    },

    // 鼠标拖拽
    mouseDrag() {
      // 里层
      const el = document.querySelector('.jsmind-inner')
      // 选中节点
      let selected

      el.onmousedown = (ev) => {
        // 选中节点
        selected = this.jm.get_selected_node()
        // 标识 是否拖拽节点 避免冲突
        this.dragNodeFlag = !!selected

        const disX = ev.clientX
        const disY = ev.clientY
        const originalScrollLeft = el.scrollLeft
        const originalScrollTop = el.scrollTop
        const originalScrollBehavior = el.style['scroll-behavior']
        const originalPointerEvents = el.style['pointer-events']
        // auto: 默认值，表示滚动框立即滚动到指定位置。
        el.style['scroll-behavior'] = 'auto'
        // 鼠标移动事件是监听的整个document，这样可以使鼠标能够在元素外部移动的时候也能实现拖动
        document.onmousemove = (ev) => {
          if (this.dragNodeFlag) return
          this.drag = false
          ev.preventDefault()
          // 计算拖拽的偏移距离
          const distanceX = ev.clientX - disX
          const distanceY = ev.clientY - disY

          el.scrollTo(originalScrollLeft - distanceX, originalScrollTop - distanceY)

          // 在鼠标拖动的时候将点击事件屏蔽掉
          el.style['pointer-events'] = 'none'
          el.style.cursor = 'grabbing'
        }
        document.onmouseup = () => {
          if (!this.dragNodeFlag) {
            el.style['scroll-behavior'] = originalScrollBehavior
            el.style['pointer-events'] = originalPointerEvents
            el.style.cursor = 'grab'
          }
          document.onmousemove = document.onmouseup = null
        }
      }
    }
  }
}
</script>
  
<style lang="scss">
@import './style.scss';

.jmexpander {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>./jsmind/js/jsmind.drag.js
  ./jsmind/js/jsmind.draggable